import { Link } from "react-router-dom";

export default function AdminNavBar() {
  return (
    <>
    <div className='d-flex justify-content-center bg-body-tertiary'>
        <div>
        <Link to={'/admin/newroom'} className="btn btn-outline-danger mx-lg-3">New Room</Link>
        </div>

        <div>
        <Link to={'/admin/allroomdetails'} className="btn btn-outline-danger mx-lg-3">All Room</Link>
        </div>

        <div>
        <Link to={'/admin'} className="btn btn-outline-danger mx-lg-3">Bookings</Link>
        </div>

        <div>
        <Link to={'/admin/alluserdetails'} className="btn btn-outline-danger mx-lg-3">Users</Link>
        </div>
    </div>
    </>
  )
}
